var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[{'app-full-content': _vm.fullBlock, 'app-card-content': !_vm.fullBlock}, _vm.extraClass]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }